import { MAX_CONCURRENT_PARTS } from '../constants';






export default class Queue {




  constructor() {
    this._runningTasks = 0;
    this._fileUploads = [];
  }

  onTaskDone = () => {
    this._runningTasks -= 1;

    this.next();
  };

  runTask = (task) => {
    this._runningTasks += 1;

    task(this.onTaskDone);
  };

  getCurrentUploadTasks = () => this._fileUploads[0] && this._fileUploads[0].tasks;

  startNextUpload = () => {
    this._fileUploads.splice(0, 1);

    if (!this.getCurrentUploadTasks()) {return null;}

    return this.next();
  };

  next = () => {
    // If no uploads or if queue is full
    if (!this._fileUploads.length || this._runningTasks >= MAX_CONCURRENT_PARTS) {return null;}

    const tasks = this.getCurrentUploadTasks();

    if (tasks.length) {
      this.runTask(tasks.shift());

      return this.next();
    }

    return !this._runningTasks ? this.startNextUpload() : null;
  };

  removeUploadTasks = (assetIdToRemove) => {
    const taskIndex = this._fileUploads.findIndex(({ assetId }) => assetId === assetIdToRemove);

    if (taskIndex === -1) {return;}

    const tasksCount = this._fileUploads[taskIndex].tasks.length;

    const newUploads = [...this._fileUploads];

    newUploads.splice(taskIndex, 1);

    this._runningTasks = this._runningTasks - tasksCount;
    this._fileUploads = newUploads;

    if (taskIndex !== 0) {return;}

    this.next();
  };

  addUploadTasks = (assetId, tasks) => {
    this._fileUploads = [...this._fileUploads, { assetId, tasks }];

    this.next();
  };
}